export function getOrdinal(n: number): string {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (v >= 11 && v <= 13 ? "th" : s[v % 10] || "th");
};



